export default __webpack_public_path__ + "media/zurb/img/events/wired/life-services-timeline1-e0fd365a5360bafdfedef6c53d7f0a2d.png";